import { tw } from '@/utils/tw';
import BaseDirectTeaserTheme from 'base/components/DirektTeaser/theme';

const Button = tw.theme({
  extend: BaseDirectTeaserTheme.Button,
  base: ['border-0', 'mt-3'],
  variants: {
    colors: {
      secondary: ['bg-white', 'hover:bg-white'],
    },
    size: {
      medium: ['pl-0', 'mb-0'],
    },
  },
  defaultVariants: {
    colors: 'secondary',
  },
});

const DirectTeaser = tw.theme({
  extend: BaseDirectTeaserTheme,
  slots: {
    base: ['sm:border-t-1', 'sm:border-t-gray-300'],
    list: ['sm:border-b-1', 'sm:border-b-gray-300', 'sm:grid', 'sm:grid-cols-3', 'sm:gap-3', 'sm:pb-3'],
    item: ['sm:border-b-0', 'border-b-gray-300'],
    time: ['text-primary-700'],
  },
});

export default Object.assign(DirectTeaser, {
  Blip: BaseDirectTeaserTheme.Blip,
  Button: Button,
  Link: BaseDirectTeaserTheme.Link,
});
